// src/App.js
import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ThemeContext } from './context/ThemeContext';
import { lightTheme, darkTheme } from './styles/theme';

import Navbar from './components/Navbar';
import Homepage from './pages/Homepage';
import QuizSetup from './pages/QuizSetup';
import Quiz from './pages/Quiz';
import LiveExams from './pages/LiveExams';
import SearchResults from './pages/SearchResults';
import HistoryPage from './pages/ProfilePage'; // Re-purposed to show local history

function App() {
  const { darkMode } = useContext(ThemeContext);
  const currentTheme = darkMode ? darkTheme : lightTheme;

  return (
    <MuiThemeProvider theme={currentTheme}>
      <CssBaseline />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/quiz-setup" element={<QuizSetup />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/live-exams" element={<LiveExams />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/search" element={<SearchResults />} />
          
          {/* Support for direct local quiz route if triggered via file upload */}
          <Route path="/quiz/local" element={<Quiz />} />
        </Routes>
      </main>
    </MuiThemeProvider>
  );
}

export default App;
